import Vue from 'vue';
let successOptions = {
	type : 'success',
};
let errorOptions = {
	type : 'error'
};
export default {
	showSuccessToast : function (text) {
		Vue.toasted.show(text,successOptions)
	},
	showErrorToast : function (text) {
		Vue.toasted.show(text,errorOptions)
	}
}
